/**
 * OUTEQ — odhalování obsahu při scrollu („lazy loading" animace).
 *
 * Sekce a karty se plynule nadechnou, jak vjíždějí do viewportu. Skládá se to
 * ze dvou částí: CSS drží počáteční stav (outeq-custom.css, prefix .oq-reveal),
 * tenhle skript rozdává třídy.
 *
 * Zásady, které to drží bezpečné:
 *  - Skrytý počáteční stav zapíná až JS třídou `oq-reveal-on` na <html>. Bez
 *    JS (a pro vyhledávače) je obsah normálně vidět — nikdy se nestane, že by
 *    animace obsah „spolkla".
 *  - Záložní časovač po 3 s odhalí všechno, i kdyby observer selhal.
 *  - Animuje se jen opacity + transform, takže nevzniká layout shift ani se
 *    nehýbe LCP prvek.
 *  - První sekce na stránce (hero) a hlavička/patička se nikdy neanimují —
 *    jinak stránka při načtení „blikne".
 *  - `prefers-reduced-motion: reduce` animaci vypíná (řeší CSS).
 */
(function () {
  'use strict';

  var ROOT = document.documentElement;
  var REVEAL_CLASS = 'oq-reveal';
  var VISIBLE_CLASS = 'is-revealed';
  var FALLBACK_MS = 3000;

  // Bez podpory observeru animaci vůbec nezapínáme — obsah zůstane statický.
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Sekce, které se animovat nemají: chrome webu a překryvy. Hero (první sekce)
     se vyřazuje zvlášť podle pozice, protože jeho typ se mezi šablonami mění. */
  var SKIP = [
    'header', 'footer', 'announcement', 'popup', 'consent', 'drawer',
    'sticky', 'oq-pdpcrumbs', 'product-information', 'main-cart',
  ];

  /* Vnitřní prvky, které dostanou vlastní odhalení se schodovým zpožděním —
     karty v mřížkách. Vždy jen prvních 12, ať se u dlouhých výpisů nehromadí
     stovky observerů. */
  var CARD_SELECTORS = [
    '.outeq-bs-card', '.outeq-cat-tile', '.oq-article-card', '.outeq-rev__card',
    '.product-card', '.resource-card', '.oq-box', '.outeq-why__item', '.oq-faq__item',
  ].join(',');

  function skipSection(el) {
    var hay = ((el.id || '') + ' ' + (el.className || '')).toLowerCase();
    for (var i = 0; i < SKIP.length; i++) if (hay.indexOf(SKIP[i]) !== -1) return true;
    // Sekce nad ohybem (hero) — nechceme blikání při prvním vykreslení.
    var rect = el.getBoundingClientRect();
    return rect.top + window.scrollY < 120;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add(VISIBLE_CLASS);
      observer.unobserve(entry.target);      // jednorázově, animace se neopakuje
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function prepare(el, delayIndex) {
    if (!el || el.classList.contains(REVEAL_CLASS)) return;
    el.classList.add(REVEAL_CLASS);
    // 35 ms na kartu (dřív 60): schodek má být znát, ale ne tak, aby poslední
    // karta v řadě zůstala půl vteřiny průsvitná — bílá karta přes světle šedé
    // pozadí stránky v té chvíli vypadá, jako by měla fotka šedý podklad.
    if (delayIndex) el.style.setProperty('--oq-reveal-delay', (delayIndex * 35) + 'ms');
    observer.observe(el);
  }

  function scan(scope) {
    var root = scope || document;

    var sections = root.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (skipSection(s)) continue;
      // Animujeme vnitřní obal, ne .shopify-section — sekce často nese pozadí
      // přes celou šířku a to by se posouvalo s obsahem.
      prepare(s.firstElementChild || s, 0);
    }

    var cards = root.querySelectorAll(CARD_SELECTORS);
    var used = 0;
    for (var j = 0; j < cards.length && used < 12; j++) {
      var c = cards[j];
      if (c.closest('.oq-reveal') === null) continue;   // jen karty uvnitř animované sekce
      prepare(c, (used % 4) + 1);
      used++;
    }
  }

  function start() {
    ROOT.classList.add('oq-reveal-on');
    scan(document);
    // Záchranná brzda: kdyby observer z jakéhokoli důvodu nedoběhl, obsah odkryjeme.
    setTimeout(function () {
      var hidden = document.querySelectorAll('.' + REVEAL_CLASS + ':not(.' + VISIBLE_CLASS + ')');
      for (var i = 0; i < hidden.length; i++) hidden[i].classList.add(VISIBLE_CLASS);
    }, FALLBACK_MS);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Obsah dopsaný později (stránkování výpisů, quick-add, výměna sekcí v editoru).
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('oq:content-updated', function (e) { scan(e.target || document); });
})();
